<template>
  <div>
    <div class="vasion-white-background vasion-calc-height vld-parent">
      <Loading
        :active.sync="isLoading"
        :is-full-page="false"
        :color="loaderColor"
        loader="dots"
        :background-color="loaderBackgroundColor"
      />
      <div class="inner-div">
        <div class="md-layout">
          <div class="md-layout-item vasion-page-title">
            Advanced Image Processing
          </div>
          <div class="md-layout-item vasion-flex-end">
            <VasionButton v-if="isDataAvailable" :classProp="'primary'" @vasionButtonClicked="createNewClicked()">
              New AIP
            </VasionButton>
          </div>
        </div>
        <div v-if="whiteScreen === true">
          <!-- Show white space while waiting for data to load -->
        </div>
        <div v-else-if="isDataAvailable === true && tableData.Columns" class="grid-div vasion-html-table-default">
          <VasionTable
            :headerColumns="tableData.Columns.Values"
            :tableRows="tableData.Rows.Values"
            :hideColumns="hiddenColumns"
            :filterByColumnDefault="1"
            :ellipsisButtonConfig="ellipsisButtonConfig"
            @ellipsis-button-clicked="ellipsisButtonClicked"
          />
        </div>
        <div v-else class="no-items-div">
          <div class="vasion-page-subheader instructional-message-div">
            No data to show.
          </div>
          <div class="button-div">
            <VasionButton :isFullWidth="true" :classProp="'primary'" @vasionButtonClicked="createNewClicked()">
              <span class="vasion-button-plus"> + </span> ADD NEW
            </VasionButton>
          </div>
        </div>
      </div>

      <VasionGeneralModal
        id="aip-delete-modal"
        :modalType="'message'"
        buttonGroup="center"
        confirmButtonText="Yes"
        rejectButtonText="No"
        :message="deleteMessage"
        :sync="showDeleteModal"
        @noButtonClick="toggleDeleteModal"
        @confirmButtonClick="deleteAip"
      />

      <VasionSnackbar
        id="results-snack"
        :showSnackbarBool.sync="showSnackbar"
        :snackbarImage="snackbarImage"
        :snackbarSubTitle="snackbarSubTitle"
        :snackbarTitle="snackbarTitle"
      />
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
  name: 'AdvancedImageProcessing',
  components: {
    Loading,
  },
  data: function () {
    return {
      aipID: 0,
      aipName: '',
      columns: {
        Values: [
          '_AipID_',
          'Name',
          'Object',
          '_VasionEllipsisButton_',
        ],
        ValueType: 'String',
      },
      deleteMessage: '',
      hiddenColumns: ['_AipID_'],
      isLoading: false,
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
      showDeleteModal: false,
      showSnackbar: false,
      snackbarImage: false,
      snackbarSubTitle: '',
      snackbarTitle: '',
      tableData: {},
      whiteScreen: true,
    }
  },
  computed: {
    aipData() { return this.$store.state.capture.aipData },
    ellipsisButtonConfig() { return this.$store.state.security.ellipsisButtonConfig },
    isDataAvailable() { return this.aipData.Values && this.aipData.Values.length > 0 },
  },
  async created() {
    await this.$store.dispatch('security/setEllipsisButtonConfig', 'aip-buttons')
    await this.refreshTable()
  },
  methods: {
    createNewClicked() { this.$router.push({ name: 'EditAIP', params: { AIPID: 0 } }) },
    async deleteAip() {
      const response = await this.$store.dispatch('capture/deleteAip', this.aipID)
      this.showDeleteModal = false

      this.snackbarTitle = !response ? 'Error Deleting Advanced Image Process' : `Advanced Image Process: "${this.aipName}" Deleted Successfully`
      this.snackbarSubTitle = !response ? 'If the problem persists, please contact your Administrator' : 'The Advanced Image Process has been deleted.'
      this.snackbarImage = response
      this.showSnackbar = true;
      this.refreshTable()
    },
    ellipsisButtonClicked(payload) {
      if (payload?.item?.Values[0]) {
        [this.aipID, this.aipName] = [payload.item.Values[0], payload.item.Values[1]]

        switch (payload.buttonId) {
          case 'edit-aip-button':
            this.$router.push({ name: 'EditAIP', params: { AIPID: this.aipID } })
            break;
          case 'delete-aip-button':
            this.deleteMessage = `Are you sure you want to delete "${this.aipName}"?`
            this.toggleDeleteModal()
            break;
          default:
            break;
        }
      }
    },
    async refreshTable() {
      this.isLoading = true
      await this.$store.dispatch('capture/getAllAipProcs')
      this.whiteScreen = false
      const data = {
        aipList: this.aipData.Values,
        columns: this.columns,
        type: 'Aip',
      }
      this.tableData = await this.$store.dispatch('capture/setTableData', data)
      this.isLoading = false
    },
    toggleDeleteModal() { this.showDeleteModal = !this.showDeleteModal },
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/variables.scss';

  .button-div {
    margin: auto;
    margin-top: 30px;
    width: 288px;
  }

  .inner-div {
    padding-top: 8px;
    margin-right: 8px;
    margin-left: 16px;
    text-align: center;
  }

  .instructional-message-div {
    margin-top: 24px;
  }

  .main-div {
    background-color: white;
    width: 100%;
  }

  .no-items-div {
    margin-top: 60px;
  }

  .grid-div {
    height: calc(100vh - 125px);
    overflow: auto;
    text-align: left;
  }
</style>
